var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSenteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 148 39",
    style: {
      enableBackground: "new 0 0 148 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8E8E8;}\n\t.st1{fill:url(#Shape_00000178883799451983663550000000971126191050317188_);}\n\t.st2{fill:url(#Shape_00000098196132099293426500000015174014847528855714_);}\n\t.st3{fill:url(#Shape_00000116217774756689644090000005611966816137657740_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-study",
    transform: "translate(-146.000000, -42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_5_",
    transform: "translate(146.000000, 42.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(47.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M19.2,10.7c-2.7-0.4-5-0.4-6.8-0.4c-1.9,0-4.3,0.2-4.3,2.5c0,1.2,0.8,1.5,2.9,2.5l1.7,0.8 c3.9,1.7,5.4,3.1,5.4,6.4c0,5.2-4.1,7.4-10.3,7.4c-3.1,0-6.6-0.6-7.4-0.8l0.6-3.5C3.1,25.8,5.2,26,8.4,26c2.5,0,4.7-0.4,4.7-2.7 c0-1.4-0.6-1.7-3.3-2.9l-1.6-0.6c-3.5-1.6-5-3.3-5-6.4c0-5.6,4.7-6.8,9.5-6.8c3.3,0,6,0.4,7.6,0.8L19.2,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000068675204791060673580000009381749234586112422_",
    className: "st0",
    d: "M40.8,19.6h-15c-0.2,1.2-0.4,1.9-0.4,2.5 c0,2.1,1.2,3.3,5.2,3.3c2.3,0,5.2-0.2,8.2-0.6l-0.6,3.9c-1.7,0.4-4.9,1-8.5,1c-6.4,0-9.3-2.5-9.3-7.8c0-1.2,0.2-2.5,0.4-3.9 l0.2-1.4c1.6-7.4,5.6-10.5,11.7-10.5c5.8,0,8.7,2.9,8.7,7.9C41.6,15.7,41.2,17.4,40.8,19.6z M32.4,10.5c-4.1,0-5.4,2.9-5.8,5.4 v0.4h9.7c0.2-0.8,0.2-1.5,0.2-2.1C36.5,12,35.7,10.5,32.4,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000127006085042474289060000004778681416701119126_",
    className: "st0",
    d: "M63.5,15.5l-2.3,13.6h-5.2l2.5-14.1 c0.2-0.8,0.2-1.6,0.2-2.1c0-1.6-0.8-2.3-2.7-2.3c-1.7,0-3.7,0.4-6,1.6L47,28.9h-5.2l3.9-22.3h5l-0.2,1.7C53,6.8,55.7,6,57.9,6 c4.7,0,6,2.5,6,5.8C63.9,13,63.7,14.3,63.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000027593184661554004000000002729591662312034492_",
    className: "st0",
    d: "M80.2,10.8h-5.4l-2.1,12 c-0.2,0.8-0.2,1.2-0.2,1.6c0,0.8,0.4,1.2,1.7,1.2c1.2,0,2.7,0,3.3-0.2l-0.6,3.5c-0.6,0.2-2.5,0.6-4.7,0.6 c-3.7,0-5.2-1.6-5.2-4.7c0-0.6,0-1.4,0.2-2.1l2.1-11.8l-4.1-0.4l0.6-3.9h4.1l1-5.6h5.2l-1,5.6h5.4L80.2,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000168093353639594098360000011165063388842929819_",
    className: "st0",
    d: "M100,19.6h-15c-0.2,1.2-0.4,1.9-0.4,2.5 c0,2.1,1.2,3.3,5.2,3.3c2.3,0,5.2-0.2,8.2-0.6l-0.6,3.9c-1.7,0.4-4.9,1-8.5,1c-6.4,0-9.3-2.5-9.3-7.8c0-1.2,0.2-2.5,0.4-3.9 l0.2-1.4c1.6-7.4,5.6-10.5,11.7-10.5c5.8,0,8.7,2.9,8.7,7.9C100.6,15.7,100.4,17.4,100,19.6z M91.5,10.5c-4.1,0-5.4,2.9-5.8,5.4 v0.4h9.7c0.2-0.8,0.2-1.5,0.2-2.1C95.6,12,94.8,10.5,91.5,10.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_00000027570201097939202400000004182172005818766501_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_00000172437803774795959540000015711926503623099521_",
    gradientUnits: "userSpaceOnUse",
    x1: -218.3046,
    y1: 390.2881,
    x2: -217.6797,
    y2: 391.2197,
    gradientTransform: "matrix(47.6821 0 0 -8.12 10455.0615 3179.2866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#F0EFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFD1D2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000003791900358649809460000007422482975978424724_",
    style: {
      fill: "url(#Shape_00000172437803774795959540000015711926503623099521_)"
    },
    d: " M59.7,0.3c-2.3,0-5.8,1.3-8,2.9L45,8.4h32.9c2.3,0,5.8-1.3,8-2.9l6.8-5.2H59.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_00000127765091881044077160000011190025597765505206_",
    gradientUnits: "userSpaceOnUse",
    x1: -218.2988,
    y1: 391.0058,
    x2: -217.3425,
    y2: 391.0058,
    gradientTransform: "matrix(47.6821 0 0 -8.12 10431.9023 3183.7668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAEC41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1801,
    style: {
      stopColor: "#F7CD36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F5B22D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F39F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7812,
    style: {
      stopColor: "#F29422"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F29021"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000021086047930735225000000004557183977104962486_",
    style: {
      fill: "url(#Shape_00000127765091881044077160000011190025597765505206_)"
    },
    d: " M36.6,4.7c-2.3,0-5.8,1.3-8,2.9l-6.8,5.2h32.9c2.3,0,5.8-1.3,8-2.9l6.8-5.2H36.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Shape_00000047056413106964364950000017258731005825000584_",
    gradientUnits: "userSpaceOnUse",
    x1: -218.7412,
    y1: 390.9112,
    x2: -217.611,
    y2: 391.0276,
    gradientTransform: "matrix(47.6821 0 0 -8.12 10410.1045 3187.6873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2518,
    style: {
      stopColor: "#E31469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2673,
    style: {
      stopColor: "#DF1467"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4065,
    style: {
      stopColor: "#BD1459"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    style: {
      stopColor: "#A2154E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6934,
    style: {
      stopColor: "#8F1546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#841542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801540"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000163781260323290472270000002565881443523389868_",
    style: {
      fill: "url(#Shape_00000047056413106964364950000017258731005825000584_)"
    },
    d: " M14.8,8.7c-2.3,0-5.8,1.3-8,2.9L0,16.8h32.9c2.3,0,5.8-1.3,8-2.9l6.8-5.2H14.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenteLogo);
export default __webpack_public_path__ + "static/media/Sente_Logo.a6ac0c3c5c54e7fb6e820a91e2e3f1f3.svg";
export { ForwardRef as ReactComponent };